// Увести человека на страницу оплаты ЮKassa. SMY-341
//
// Страница чужая, и открывается она новой вкладкой: в этой же вкладке человек,
// передумавший платить, потерял бы кабинет. Но новую вкладку браузер даёт только
// в ответ на жест, а ссылку на оплату мы получаем позже — после запроса к
// серверу, а у гостя ещё и после регистрации (`purchase.tsx`). Жест к этому
// моменту остывает, и окно блокируется молча, особенно в Safari: человек нажал
// «Оплатить», и ничего не произошло.
//
// Поэтому `noreferrer` здесь нет: с ним `window.open` возвращает `null` всегда,
// и заблокированное окно не отличить от открытого. Без него ссылка на открытое
// окно приходит, и у страницы оплаты сразу отбирается `opener` — чужая страница
// не должна дотягиваться до кабинета. Не открылось — уходим на оплату в этой
// же вкладке: ЮKassa вернёт на экран тарифов, а токен к этому моменту лежит в
// постоянном хранилище (`keepSignedIn` в token-store.ts).

const isHttps = (url: string): boolean => {
  try {
    return new URL(url).protocol === 'https:'
  } catch {
    return false
  }
}

/** То, чем пользуется помощник, — чтобы проверка обходилась без браузера. */
export interface PaymentWindow {
  open: (url: string, target: string) => { opener: unknown } | null
  location: { assign: (url: string) => void }
}

/**
 * Открыть оплату. `'tab'` — новой вкладкой, `'here'` — окно заблокировано, ушли в этой.
 *
 * ⚠️ ТОЛЬКО HTTPS (21.09.2026, агент security). Без `noopener` окно наследует
 * происхождение кабинета, а `location.assign` исполняет адрес прямо в нём:
 * ссылка `javascript:` из подменённого ответа эквайринга прочла бы токен.
 * Сервер такую ссылку отбрасывает сам (`isHttpsUrl` в billing/yookassa.ts), это
 * второй рубеж. Отказ уходит экрану текстом.
 */
export function openPayment(url: string, win: PaymentWindow = window as unknown as PaymentWindow): 'tab' | 'here' {
  if (!isHttps(url)) throw new Error('Эквайринг дал неверную ссылку на оплату. Попробуй позже')
  const tab = win.open(url, '_blank')
  if (tab == null) {
    win.location.assign(url)
    return 'here'
  }
  tab.opener = null
  return 'tab'
}
